import React, { useState, useEffect } from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Features from "../components/landing/Features";
import HostingDetails from "../components/landing/HostingDetails";
import Pricing from "../components/landing/Pricing";
import Testimonials from "../components/landing/Testimonials";
import ContactSection from "../components/landing/ContactSection";
import Footer from "../components/landing/Footer";
import MobileHeader from "../components/mobile/MobileHeader";
import FirstVisitPopup from "../components/landing/FirstVisitPopup";
import PullToRefresh from "../components/mobile/PullToRefresh";
import SideTab from "../components/landing/SideTab";

export default function Home() {
  const isMobile = useIsMobile();
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 700);
    }
  }, []);

  const handleRefresh = async () => {
    setRefreshing(true);
    // Simulate refresh delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    setRefreshing(false);
  };

  return (
    <div className="min-h-screen bg-background">
      {isMobile ? (
        <>
          <div>
            <PullToRefresh onRefresh={handleRefresh} />
            <Hero />
            <Features />
            <HostingDetails />
            <Pricing />
            <Testimonials />
            <ContactSection />
            <Footer />
          </div>
        </>
      ) : (
        <>
          <Hero />
          <Features />
          <HostingDetails />
          <Pricing />
          <Testimonials />
          <ContactSection />
          <Footer />
        </>
      )}
      <FirstVisitPopup />
    </div>
  );
}